import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Hero from "../../assets/svg/Landing/HeroImage.svg";
import HeroMobile from "../../assets/svg/Landing/HeroMobile.svg";

const HeroSection = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: (custom) => ({
      opacity: 1,
      y: 0,
      transition: { delay: custom * 0.2, duration: 0.5 }
    })
  };

  return (
    <section
      className="bg-white text-white relative h-full min-h-[500px] xs:min-h-[550px] sm:min-h-[600px] md:min-h-[700px] lg:min-h-[799px]"
      style={{
        backgroundImage:
          windowWidth > 1024 ? `url(${Hero})` : `url(${HeroMobile})`,
        backgroundSize: windowWidth > 1024 ? "cover" : "contain",
        backgroundPosition: windowWidth > 768 ? "right" : "center bottom",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Decorative element - responsive positioning */}
      <motion.div 
        initial={{ width: 0 }}
        animate={{ width: "7rem" }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className="hidden sl:flex absolute top-[8rem] xs:top-[10rem] sm:top-[12rem] md:top-[14.3rem] left-0 border-primary bg-primary border-2 h-6 xs:h-8 md:h-10" 
      />

      <div className="container mx-auto flex flex-col md:flex-row items-start relative z-10 px-4 sm:px-6 md:px-8">
        <div className="w-full md:w-2/3 pt-16 xs:pt-20 sm:pt-24 md:pt-[14rem] md:pl-4 lg:pl-28 text-primary space-y-4 sm:space-y-6 md:space-y-8 lg:space-y-10">
          {/* Heading section - responsive text sizes */}
          <div>
            <motion.h1 
              custom={0}
              initial="hidden"
              animate="visible"
              variants={fadeIn}
              className="text-3xl xs:text-4xl sm:text-5xl font-bold mb-1 sm:mb-2"
            >
              Learn <span className="font-normal">a New Skill</span>
            </motion.h1>
            <motion.h2 
              custom={1}
              initial="hidden"
              animate="visible"
              variants={fadeIn}
              className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-normal mb-1 sm:mb-2 md:mb-4"
            >
              Everyday, Anytime,
            </motion.h2>
            <motion.h2 
              custom={2}
              initial="hidden"
              animate="visible"
              variants={fadeIn}
              className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-normal mb-2 sm:mb-3 md:mb-4"
            >
              and Anywhere.
            </motion.h2>
          </div>

          {/* Description section - responsive text and spacing */}
          <motion.div 
            custom={3}
            initial="hidden"
            animate="visible"
            variants={fadeIn}
            className="mt-4 sm:mt-6 md:mt-8"
          >
            <p className="text-sm xs:text-base md:text-lg text-gray-500 leading-relaxed">
              1000+ Courses covering all tech domains for you to
              <br className="hidden xs:block" />
              learn and explore new opportunities. Learn from
              <br className="hidden xs:block" />
              Industry Experts and land your Dream Job.
            </p>
          </motion.div>

          {/* CTA Button - responsive sizing */}
          <motion.div 
            custom={4}
            initial="hidden"
            animate="visible"
            variants={fadeIn}
            className="pt-4 sm:pt-6 md:pt-8"
          >
            <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-primary text-white font-medium py-2 px-4 sm:py-3 sm:px-6 rounded-md hover:bg-primary-hover transition duration-300"
            >
              Get Started
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
